
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface FestivalDetailsProps {
  startDate: string;
  setStartDate: (value: string) => void;
  endDate: string;
  setEndDate: (value: string) => void;
  frequency: string;
  setFrequency: (value: string) => void;
  ticketPrice: string;
  setTicketPrice: (value: string) => void;
  categories: string;
  setCategories: (value: string) => void;
  capacity: string;
  setCapacity: (value: string) => void;
  familyFriendly: boolean;
  setFamilyFriendly: (value: boolean) => void;
  hasFood: boolean;
  setHasFood: (value: boolean) => void;
  isExistingPlace?: boolean;
}

export function FestivalDetails({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  frequency,
  setFrequency,
  ticketPrice,
  setTicketPrice,
  categories,
  setCategories,
  capacity,
  setCapacity,
  familyFriendly,
  setFamilyFriendly,
  hasFood,
  setHasFood,
  isExistingPlace = false
}: FestivalDetailsProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Start Date</Label>
          <Input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className={isExistingPlace ? "bg-gray-50" : ""}
            readOnly={isExistingPlace}
          />
        </div>

        <div className="space-y-2">
          <Label>End Date</Label>
          <Input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className={isExistingPlace ? "bg-gray-50" : ""}
            readOnly={isExistingPlace}
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label>Frequency</Label>
        <Select 
          value={frequency} 
          onValueChange={setFrequency}
          disabled={isExistingPlace}
        >
          <SelectTrigger className={isExistingPlace ? "bg-gray-50" : ""}>
            <SelectValue placeholder="Select frequency" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="one_time">One-time Event</SelectItem>
            <SelectItem value="annual">Annual</SelectItem>
            <SelectItem value="biannual">Biannual</SelectItem>
            <SelectItem value="monthly">Monthly</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Ticket Price Range ($)</Label>
        <Input
          type="text"
          value={ticketPrice}
          onChange={(e) => setTicketPrice(e.target.value)}
          placeholder="e.g., 50-100, Free"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>

      <div className="space-y-2">
        <Label>Categories</Label>
        <Input
          value={categories}
          onChange={(e) => setCategories(e.target.value)}
          placeholder="e.g., Music, Food, Cultural (comma separated)"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>

      <div className="space-y-2">
        <Label>Capacity</Label>
        <Input
          type="number"
          value={capacity}
          onChange={(e) => setCapacity(e.target.value)}
          placeholder="Maximum number of attendees"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>

      <div className="flex items-center space-x-2">
        <Switch
          checked={familyFriendly}
          onCheckedChange={setFamilyFriendly}
          disabled={isExistingPlace}
        />
        <Label className={isExistingPlace ? "text-muted-foreground" : ""}>
          Family Friendly
        </Label>
      </div>

      <div className="flex items-center space-x-2">
        <Switch
          checked={hasFood}
          onCheckedChange={setHasFood}
          disabled={isExistingPlace}
        />
        <Label className={isExistingPlace ? "text-muted-foreground" : ""}>
          Food & Beverages Available
        </Label>
      </div>
    </div>
  );
}
